import React from 'react'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { setCloseSkyVideoPlayer, setEntitlementStatus } from '@core/Areas/SkyVideoPlayer/Store'
import { fetchFromApi } from '@core/Services/ApiService'
import { useAppDispatch, useAppSelector } from '@core/Store/hooks'

interface VisionEntitlementCheckRes {
  CallToAction: null
  Condition: string
  Entitlement: { BamEntitlementId: string }
  HiddenReasonText: string | null
  IsEntitled: boolean
  ReasonText: string | null
}

export const useEntitlement = () => {
  const dispatch = useAppDispatch()
  const isEntitled = useAppSelector(state => state.skyVideoPlayer.isEntitled)

  React.useEffect(() => {
    if (typeof isEntitled === 'boolean') {
      return
    }

    fetchFromApi('/Vision/EntitlementCheck')
      .then(res => res.json())
      .then(({ IsEntitled, ReasonText }: VisionEntitlementCheckRes) => {
        const notEntitledMessage = ReasonText || 'Not authorised to view Vision'
        // Delay Close (Android 10 crashes if too soon)
        if (!IsEntitled) {
          setTimeout(() => {
            dispatch(setCloseSkyVideoPlayer())
            displayVisionNotEntitledMessage(notEntitledMessage)
          }, 2000)
        }

        // Update Vision State
        dispatch(
          setEntitlementStatus({
            isEntitled: IsEntitled,
            notEntitledMessage: !IsEntitled ? notEntitledMessage : undefined,
          })
        )
      })
  }, [dispatch, isEntitled])
}

export function displayVisionNotEntitledMessage(message: string) {
  addToast({
    id: 'VisionNotEntitled',
    title: message,
    icon: 'error',
    timeoutMs: Infinity,
    isDismissable: true,
  })
}
